module.exports = __webpack_public_path__ + "img/sentosa-wave-white.e39c2a91.svg";